export enum types {
  MODAL_OPEN = 'modal/open',
  MODAL_CHANGE = 'modal/change',
  MODAL_CLOSE = 'modal/close',
}